import React from "react";
import logo from "./assets/logo.webp";
import { NavLink } from "react-router-dom";
import { RiMenu3Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { LuPhoneCall } from "react-icons/lu";
import { IoMailOpenOutline } from "react-icons/io5";

function Navbar() {
  return (
    <>
      <header id="header" className="header sticky-top">
        <div className="container-fluid container-xl position-relative">
          <div className="top-row d-flex align-items-center justify-content-between">
            <a to="/" className="logo d-flex align-items-center">
              {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
              <img src={logo} alt="logo" className="logoimg" />
              {/* <h1 className="sitename">FlexBiz</h1> */}
            </a>

            <div className="d-flex align-items-center">
              <div className="social-links">
                <a href="/" className="facebook">
                  <LuPhoneCall />
                </a>

                <a
                  href="mailto:klacentralcommittee@gmail.com"
                  className="facebook me-2"
                >
                  <IoMailOpenOutline
                    style={{ fontSize: "20px", margin: "auto 10px" }}
                  />
                </a>
              </div>

              {/* <form className="search-form ms-4">
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control"
                />
                <button type="submit" className="btn">
                  <CiSearch />
                </button>
              </form> */}
            </div>
          </div>
        </div>

        <div className="nav-wrap">
          <div className="container d-flex justify-content-center position-relative">
            <nav id="navmenu" className="navmenu">
              <ul>
                <li>
                  <NavLink
                    to="/"
                    end
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Home
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/about-us"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/gallery"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Gallery
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/publications"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Publications
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/committee"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Committee
                  </NavLink>
                </li>

                {/* <li className="dropdown">
                  <a href="#">
                    <span>Dropdown</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#">Dropdown 1</a>
                    </li>
                    <li className="dropdown">
                      <a href="#">
                        <span>Deep Dropdown</span>{" "}
                        <i className="bi bi-chevron-down toggle-dropdown"></i>
                      </a>
                      <ul>
                        <li>
                          <a href="#">Deep Dropdown 1</a>
                        </li>
                        <li>
                          <a href="#">Deep Dropdown 2</a>
                        </li>
                        <li>
                          <a href="#">Deep Dropdown 3</a>
                        </li>
                        <li>
                          <a href="#">Deep Dropdown 4</a>
                        </li>
                        <li>
                          <a href="#">Deep Dropdown 5</a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="#">Dropdown 2</a>
                    </li>
                    <li>
                      <a href="#">Dropdown 3</a>
                    </li>
                    <li>
                      <a href="#">Dropdown 4</a>
                    </li>
                  </ul>
                </li> */}
                <li>
                  <NavLink
                    to="/contact-us"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Contact
                  </NavLink>
                </li>
                <li>
                  <Link to="/login" target="_blank">
                    Login
                  </Link>
                </li>
              </ul>
              <RiMenu3Fill className="mobile-nav-toggle d-xl-none" />
              {/* <i className="mobile-nav-toggle d-xl-none bi bi-list"></i> */}
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
